import { render, staticRenderFns } from "./Wap_WXCW81_WCBJ_Record.vue?vue&type=template&id=5aed5bef&scoped=true&"
import script from "./Wap_WXCW81_WCBJ_Record.vue?vue&type=script&lang=js&"
export * from "./Wap_WXCW81_WCBJ_Record.vue?vue&type=script&lang=js&"
import style0 from "./Wap_WXCW81_WCBJ_Record.vue?vue&type=style&index=0&id=5aed5bef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed5bef",
  null
  
)

export default component.exports